import { GameDefinition } from './types';

export const LA_FAMIGLIA_GAME_ID = 'la-famiglia';

export const laFamigliaGameListing = {
  id: LA_FAMIGLIA_GAME_ID,
  title: 'La Famiglia: The Great Mafia War',
  subtitle: '2vs2 · oficjalne 1vs1 i 2vs1',
  icon: '🇮🇹',
  players: '2–4 graczy',
  playTime: '90–180 min',
  contentStatus: 'ready' as const,
  logoAccessibilityLabel: 'Logo gry La Famiglia: The Great Mafia War',
};

export const laFamigliaGameDefinition: GameDefinition = {
  game: laFamigliaGameListing,
  shortTitle: 'La Famiglia',
  author: 'Boardgame Atelier',
  recommendedFirstGamePlayers: '4 graczy (2vs2)',
  difficulty: 'zaawansowana',
  instructionLanguage: 'polski',
  contentStatus: 'ready',
};

export const FIRST_GAME_RECOMMENDATION_4 =
  'Na pierwszą partię 2vs2 zaleca się rodziny żółtą, czerwoną, zieloną i niebieską (bez czarnej i białej).';

export const FIRST_GAME_RECOMMENDATION_2 =
  'Na pierwszą partię 1vs1 zaleca się rodziny żółtą i zieloną jako rodziny samotne.';

export const FIRST_GAME_RECOMMENDATION_3 =
  'Na pierwszą partię 2vs1 zaleca się poziom średni oraz żółtą/zieloną dla gracza samotnego.';

export const HAS_LA_FAMIGLIA_LOGO = true;
